import React, { useEffect, useState } from "react";
import {
  Grid,
  RadioGroup,
  FormControlLabel,
  Radio,
  Button,
  CircularProgress,
  TextField,
  Typography,
} from "@mui/material";
import Rating from "@mui/material/Rating";
import "../../Feedback.css";
import { toast, ToastContainer } from "react-toastify";
import { Loginimg } from "../Assets/Icon";

function FeedbackSubmitPage() {
  const queryParams = new URLSearchParams(window.location.search);
  const qData = queryParams.get("q");
  const [questionDetails, setQuestionDetails] = useState([]);
  const [loading, setLoading] = useState(false);
  const [mobileNum, setMobileNum] = useState("");

  const decodeBase64MultipleTimes = (encodedData, times = 4) => {
    let decoded = encodedData;
    for (let i = 0; i < times; i++) {
      decoded = atob(decoded); // Decode base64
    }
    return decoded;
  };

  const decodeKeyApi = async () => {
    console.log("decodeKeyApi");

    try {
      const response = await global.$axios.get(
        `feedback/get_feedback_statusform/${qData}`
      );
      if (response.data.Status == 200) {
        setQuestionDetails(response.data.Message.feedbackData);
      }
    } catch (error) {
      console.error("feedback/get_feedback_statusform", error);
    }
  };

  useEffect(() => {
    decodeKeyApi();
    const decoded = decodeBase64MultipleTimes(qData, 4);
    const parsedData = JSON.parse(decoded);
    setMobileNum(parsedData.Pura_whatsapp);
  }, []);

  const Redirect = (mobileNum) => {
    console.log("User Agent:", navigator.userAgent);

    const isMobile = /Android|iPhone|iPad/i.test(navigator.userAgent);

    const whatsappUrl = `https://wa.me/${mobileNum}?text`;

    if (isMobile) {
      // Try to open the app with the universal wa.me link
      window.location.href = whatsappUrl;
    } else {
      // Desktop will open WhatsApp Web
      window.open(whatsappUrl, "_blank");
    }
  };

  const EnterValue = (value, index) => {
    let updateQuestion = questionDetails;
    updateQuestion[index].Value = value;
    setQuestionDetails([...updateQuestion]);
  };

  const handleSubmit = async () => {
    const isValid = questionDetails.every((item) =>
      item.hasOwnProperty("Value")
    );
    if (!isValid) {
      toast.error("All questions must have a Value.");
      return;
    }
    setLoading(true);
    try {
      let payload = {
        Code: qData,
        question: questionDetails,
      };
      const response = await global.$axios.post(
        "feedback/submit_feedback_form",
        payload
      );
      if (response.data.Status == 200) {
        toast.success("Feedback submitted !");
        Redirect();
      } else {
        toast.error(response.data.Message);
      }
    } catch (error) {
      console.error("feedback/submit_feedback_form", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Grid container justifyContent="center" alignItems="start">
      <Grid
        item
        xs={12}
        md={4}
        sm={6}
        sx={{
          maxHeight: "95vh",
          borderRadius: "10px",
          border: "1px solid #23232350",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {/* Header */}
        <Grid
          item
          xs={12}
          sx={{
            display: "flex",
            background: "#0275F6",
            height: "10vh",
            alignItems: "center",
            gap: "16px",
            padding: "10px",
            borderTopRightRadius: "10px",
            borderTopLeftRadius: "10px",
          }}
        >
          <Loginimg height={24} width={24} />
          <Typography sx={{ fontSize: "16px", color: "#fff", fontWeight: 600 }}>
            Feedback Survey
          </Typography>
        </Grid>

        {qData ? (
          <>
            {/* Scrollable Questions Container */}
            <Grid
              item
              xs={12}
              sx={{
                flex: 1,
                overflowY: "auto",
                padding: "10px",
                maxHeight: "calc(95vh - 10vh - 60px)", // Adjusting for header and button
                backgroundColor: "#cfe6ff",
              }}
            >
              {questionDetails?.map((x, index) => (
                <Grid
                  item
                  xs={12}
                  key={index}
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    marginBottom: "12px",
                  }}
                >
                  <Typography
                    sx={{
                      fontWeight: 500,
                      fontSize: "14px",
                      color: "#232323",
                    }}
                  >
                    {x.Question}
                  </Typography>

                  {x.feedbackRatingId === 1 && (
                    <TextField
                      fullWidth
                      variant="outlined"
                      value={x?.Value}
                      onChange={(e) => EnterValue(e.target.value, index)}
                    />
                  )}

                  {x.feedbackRatingId === 2 && (
                    <RadioGroup
                      row
                      value={String(x?.Value)}
                      onChange={(e) => EnterValue(e.target.value, index)}
                    >
                      <FormControlLabel
                        value="Yes"
                        control={<Radio />}
                        label="Yes"
                      />
                      <FormControlLabel
                        value="No"
                        control={<Radio />}
                        label="No"
                      />
                    </RadioGroup>
                  )}

                  {x.feedbackRatingId === 3 && (
                    <Rating
                      precision={0.5}
                      value={x?.Value || 0}
                      onChange={(event, newValue) =>
                        EnterValue(newValue, index)
                      }
                    />
                  )}
                </Grid>
              ))}
            </Grid>

            {/* Submit Button - Fixed at Bottom */}
            <Grid
              item
              xs={12}
              sx={{
                padding: "10px",
                backgroundColor: "#cfe6ff",
                borderBottomLeftRadius: "10px", // ✅ Curved bottom left
                borderBottomRightRadius: "10px", // ✅ Curved bottom right
              }}
            >
              <Button
                fullWidth
                variant="contained"
                disabled={loading}
                onClick={handleSubmit}
              >
                {loading ? <CircularProgress size={24} /> : "Submit"}
              </Button>
            </Grid>
          </>
        ) : (
          <Grid
            item
            xs={12}
            sx={{
              backgroundColor: "#cfe6ff",
              textAlign: "center",
              padding: "10px",
              borderBottomLeftRadius: "10px", // ✅ Curved bottom left
              borderBottomRightRadius: "10px", // ✅ Curved bottom right
            }}
          >
            <Typography>No response received</Typography>
            <Typography>
              Engage with the customer to understand their experience.
            </Typography>
          </Grid>
        )}
      </Grid>

      <ToastContainer
        position="top-right"
        autoClose={1500}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </Grid>
  );
}

export default FeedbackSubmitPage;
